<section class="breadcrumbs-placeholder">
</section>
<section class="index h-75 d-flex align-items-center">
  <div class="container container-index container-buttons">
    <div *ngFor="let x of visualItemsInfoButtons; let last = last; let index = index">
      <div [ngClass]="rowCssClass(index)">
        <div *ngFor="let y of x" class="col-12 col-md-4" [ngClass]="y.cssClass" align="center">
          <app-visual-item-info [visualItemInfo]="y">
          </app-visual-item-info>
        </div>
      </div>
    </div>
  </div>
</section>
